import { BeanCounter, type BeanCounterConfig } from './trackers/BeanCounter';

const beanCounterTracker = new BeanCounter();

export function getBeanCounterTracker(): BeanCounter {
    return beanCounterTracker;
}

export function updateBeanCounterConfig(config: Partial<BeanCounterConfig>): void {
    beanCounterTracker.updateConfig(config);
}
